<template>
  <gl-table-two-columns title="Summary" :rows="prepareData()" />
</template>

<script>
import GlTableTwoColumns from '@gl/GlTableTwoColumns/GlTableTwoColumns'
import { formatDistance } from 'date-fns'
import BigNumber from 'bignumber.js'

export default {
  name: 'BlockSummary',
  components: { GlTableTwoColumns },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  methods: {
    totalFees() {
      let fees = new BigNumber(0)
      this.block?.tx.forEach(tx =>
        tx?.inputs?.length ? (fees = fees.plus(tx?.inputsValue).minus(tx?.outputsValue)) : 0
      )
      return fees.div(100000000).toNumber()
    },
    totalOut() {
      let output = new BigNumber(0)
      this.block?.tx.forEach(tx => (output = output.plus(tx?.outputsValue)))
      return output.div(100000000).toNumber()
    },
    prepareData() {
      return [
        {
          title: 'Number of Transactions',
          value: this.block?.tx?.length,
        },
        {
          title: 'Total Output',
          value: this.totalOut() + ' PLC',
        },
        {
          title: 'Transaction Fees',
          value: this.totalFees() + ' PLC',
        },
        {
          title: 'Time Ago',
          value: formatDistance(new Date(this.block?.time), new Date(), { addSuffix: true }),
        },
        {
          title: 'Date and Time',
          value: new Date(this.block?.time).toUTCString(),
        },
        {
          title: 'Blocks Ago',
          value: this.block?.confirmations - 1,
        },
        {
          title: 'Size',
          value: this.block?.size + ' B',
        },
        {
          title: 'Difficulty',
          value: this.block?.difficulty.toExponential(5),
        },
        {
          title: 'Bits',
          value: this.block?.bits,
        },
        {
          title: 'Version',
          value: this.block?.version,
        },
        {
          title: 'Nonce',
          value: this.block?.nonce,
        },
      ]
    },
  },
}
</script>
